<template>
  <div id="room-zone-info">
    <transition name="fade">
      <comp-message
        v-if="showMessage"
        :msgText="messageText"
        :msgSuccess="!messageIsErr"
        :msgError="messageIsErr"
        @closeMsg="showMessage = false"
      />
    </transition>

    <div class="zone">{{ zoneDescription }}</div>

    <comp-profile
      v-for="member in memberList"
      :itsMe="member.partnerSeqId == userSeqId"
      :key="member.memberSeqId"
      :photoImage="member.partnerImage"
      :profileName="member.partnerName"
      :profileSub="member.partnerType || 'Unknown'"
      :hasButton="true"
      :btnRoomSpecific="member.partnerSeqId != userSeqId"
      :invitePending="getInvitePendingStatus(member)"
      :isAdmin="isAdmin"
      @delete-click="performKickMember(member.memberSeqId)"
      @invite-click="performConnectionInvite(member.partnerUserId)"
    />

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common'
import RoomService from '@/services/room-service'
import CompMessage from '@/components/CompMessage'
import CompProfile from '@/components/CompProfile'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'RoomZoneInfo',
  mixins: [common],
  components: {
    CompMessage,
    CompProfile,
    CompLoading
  },
  data() {
    return {
      roomSeqId: this.$route.query.roomSeqId,
      userSeqId: this.$store.state.auth.user.userSeqId,
      zoneName: this.$route.query.zone,
      isLoading: false,

      showMessage: false,
      messageText: '',
      messageIsErr: false,

      zoneDescription: '',
      memberList: this.$route.query.members,
      isAdmin: this.$route.query.isAdmin === 'true'
    }
  },
  created() {
    this.$parent.setHeader(this.zoneName)
    this.$parent.headerBack = true
    this.$parent.setBottomTab(false)

    this.performGetZoneDescription(this.zoneName)
  },
  methods: {
    performGetZoneDescription(zone) {
      this.isLoading = true

      RoomService.getZoneDescription(zone).then(
        ({ resultCode, resultData }) => {
          this.isLoading = false

          if (resultCode === 0 && !this.isEmpty(resultData)) {
            this.zoneDescription = resultData
          }
        }
      )
    },
    showInfoMessage(message, isError) {
      this.showMessage = true
      this.messageText = message
      this.messageIsErr = isError || false

      setTimeout(() => {
        this.showMessage = false
        this.messageText = ''
        this.messageIsErr = false
      }, 2000)
    },
    getInvitePendingStatus(member) {
      const connectionStatus = member.connectionStatus
      if (
        this.isEmpty(connectionStatus) ||
        connectionStatus === 'disconnected'
      ) {
        return 'none'
      } else if (connectionStatus === 'connecting') {
        return 'pending'
      }
      return 'connected'
    },
    performKickMember(memberSeqId) {
      this.isLoading = true

      RoomService.kickUserFromRoom(this.roomSeqId, memberSeqId).then(
        ({ resultMsg }) => {
          this.isLoading = false

          this.$parent.showDialog(this.zoneName, resultMsg, () => {
            this.goBack()
          })
        }
      )
    },
    performConnectionInvite(partnerEmail) {
      this.isLoading = true

      const params = {
        userIdList: [partnerEmail]
      }
      RoomService.sendEmailInvite(params).then(({ resultMsg }) => {
        this.isLoading = false

        this.$parent.showDialog(this.zoneName, resultMsg, () => {
          this.goBack()
        })
      })
    }
  }
}
</script>

<style lang="scss" src="@/scss/rooms.scss" scoped></style>
